import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=cef9ee4c&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=cef9ee4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef9ee4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cef9ee4c')) {
      api.createRecord('cef9ee4c', component.options)
    } else {
      api.reload('cef9ee4c', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=cef9ee4c&scoped=true&", function () {
      api.rerender('cef9ee4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2aEMnt2TdMfVB/JS/comp/PopupBox.vue"
export default component.exports